import { ACTION_TYPES } from '@/actions';
import { judgeHasNextPage, getPagingList } from "@/core/util";

const INIT_STATE = {
  hasMore: true,
  records: [],
  examDto: {},
  examUser:{},
  employeeName: '',
  status: '',
};

export default function examList(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取考试列表(分页)
    case ACTION_TYPES.GET_EXAM_PAGE_LIST:
      result.hasMore = judgeHasNextPage(payload);
      result.records = getPagingList(result.records, payload);
      break;
    case ACTION_TYPES.GET_EXAM_HOME:
      result.examDto = payload.examDto;
      result.employeeName = payload.employeeName;
      result.status = payload.status;
      break;
    case ACTION_TYPES.GET_EXAM_RESULT:
      result.examDto = payload.examDto;
      result.employeeName = payload.employeeName;
      result.examUser = payload.examUser;
      break;
    default:
      result = state;
  }
  return result;
}
